import { createFileRoute } from '@tanstack/react-router'
import { PropertyDetailPage } from '../../../../components/PropertyDetailPage'

export const Route = createFileRoute('/$org/properties/$propertyUid/')({
  component: PropertyDetail,
})

function PropertyDetail() {
  return <PropertyDetailPage />
}